module.exports = __webpack_public_path__ + "img/@ico_hand.8a0083e8.png";